module.exports = __webpack_public_path__ + "files/08f7cf195ae216d857a4348e039fc144.svg";